import { alpha } from '@mui/material';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react'
import {customTheme} from './../../../../config/theme/MuiTheme'


interface PropsHeader extends PropsWithChildren {
    firstTitleHeaderBlue?: string;
    secondTitleHeaderViolet?: string;
  };
  
export const GenericTitleHeader = (props:PropsHeader) => {
   
  return (
    <Box   minHeight={'88px'} bgcolor={alpha(customTheme.palette.primary.main, 0.05)} borderRadius={'4px'} >
        <Box pl={2} pt={1.25} letterSpacing={"-1px"}>
            <Typography variant={"h4"} color={customTheme.palette.primary.main}>
            {props.firstTitleHeaderBlue} <Box component={"span"}  color={customTheme.palette.accent.main}>{props.secondTitleHeaderViolet}</Box>
            </Typography>
            
            </Box>
            <Box pl={2} mt={1.25}>
                <Typography variant={"bodyLarge"} color={customTheme.palette.primary.main} sx={{opacity: '0.7'}}>{props.children}</Typography>
            </Box>

    </Box>
  )
}
